import { DataSource, Layout, Map, Panel, Splitter } from "@mcleod/components";
import { MobileCommPositionList } from "../MobileCommPositionList";

export abstract class AutogenLayoutMobileCommPositionAndMapView extends Layout {
    layoutMobileCommPositionList: MobileCommPositionList;
    panelMapView: Panel;
    positionMap: Map;
    sourceMobileCommPosition: DataSource;
    splitterTracking: Splitter;
}
